module.exports = __webpack_public_path__ + "img/chatgpt.0044745a.svg";